import { ReactKeycloakProvider } from "@react-keycloak/web";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import store from "./store/Store";
import { keycloakConfig } from "./components/Login/KeyCloak/KeyCloak";

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <ReactKeycloakProvider authClient={keycloakConfig}>
        <App />
      </ReactKeycloakProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
